import { getOSSData } from '@/api/login-api';

// OSS客户端
class OSS_CLient {
  constructor(options) {
    this.ossDefaultOptions = {
      region: 'oss-cn-zhangjiakou',
      bucket: 'erp-storage-img-new',
    };
    this.ossSTSOptions = null; // 通过asynGetSTSOptions获取
    this.uploadErrTimes = 0; // 上传出错次数 超过3次时停止请求
    this._init(options.initCb);
  }

  static getInstance(cb) {
    if (!this.instance) {
      this.instance = new OSS_CLient({ initCb: cb });
      return this.instance;
    }
    cb &&
      setTimeout(() => {
        cb();
      }, 0);
    return this.instance;
  }

  async _init(cb) {
    await this._init_STSOptions();
    cb && cb();
  }

  // 初始化STS相关参数
  async _init_STSOptions() {
    try {
      const stsOpts = await this.asynGetSTSOptions();
      this.ossSTSOptions = stsOpts;
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  asynGetSTSOptions() {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await getOSSData();
        res = JSON.parse(res);
        const { securityToken, accessKeySecret, accessKeyId } = res.credentials;
        resolve({
          stsToken: securityToken,
          accessKeySecret,
          accessKeyId,
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  genOSSClient() {
    return new OSS({
      ...this.ossDefaultOptions,
      ...this.ossSTSOptions,
    });
  }

  // 单文件上传
  singleUpload(targetUrl, file, cb = {}) {
    try {
      const _client = this.genOSSClient();
      _client
        .put(targetUrl, file)
        .then(res => {
          this.uploadErrTimes = 0;
          res.url = res.url.replace(/^http:/, 'https:');
          // 图片使用自定义域名，保证图片能够直接在线预览，而非下载
          res.url = (res.url || '').replace('erp-storage-img-new.oss-cn-zhangjiakou.aliyuncs.com', 'erp-storage-img-new.superboss.cc');
          cb.success && cb.success(res);
        })
        .catch(async err => {
          if (this.uploadErrTimes > 2) {
            this.uploadErrTimes = 0;
            cb.fail && cb.fail(err);
            return;
          }
          this.uploadErrTimes++;

          const isGet = await this._init_STSOptions();
          if (isGet) {
            this.singleUpload(targetUrl, file, cb);
          } else {
            this.uploadErrTimes = 0;
            cb.fail && cb.fail(err);
          }
        });
    } catch (error) {
      if (/accessKeyId,\saccessKeySecret/.test(error?.message)) {
        // 如果是阿里云oss初始化的相关东西未获取到，需要重新走一到初始化
        this._init_STSOptions().then(isGet => {
          if (isGet) {
            this.singleUpload(targetUrl, file, cb);
          } else {
            this.uploadErrTimes = 0;
            cb.fail && cb.fail(error);
          }
        });
      }
    }
  }

  // 分片上传
  multipartUpload(targetUrl, file, cb = {}) {
    const fileType = file.type;
    try {
      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt, res) => {
          // console.log(p);
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024,
        // headers,
        mime: fileType,
      };
      const _client = this.genOSSClient();
      _client
        .multipartUpload(targetUrl, file, {
          ...options,
        })
        .then(res => {
          this.uploadErrTimes = 0;
          cb.success && cb.success(res);
        })
        .catch(async () => {
          if (this.uploadErrTimes > 2) {
            this.uploadErrTimes = 0;
            cb.fail && cb.fail(err);
            return;
          }
          this.uploadErrTimes++;

          const isGet = await this._init_STSOptions();
          if (isGet) {
            this.multipartUpload(targetUrl, file, cb);
          } else {
            this.uploadErrTimes = 0;
            cb.fail && cb.fail(err);
          }
        });
    } catch (error) {
      if (/accessKeyId,\saccessKeySecret/.test(error?.message)) {
        // 如果是阿里云oss初始化的相关东西未获取到，需要重新走一到初始化
        this._init_STSOptions().then(isGet => {
          if (isGet) {
            this.multipartUpload(targetUrl, file, cb);
          } else {
            this.uploadErrTimes = 0;
            cb.fail && cb.fail(error);
          }
        });
      }
    }
  }
}

export default OSS_CLient;
